import { render, staticRenderFns } from "./VPlusLink.vue?vue&type=template&id=65c46860&scoped=true&"
import script from "./VPlusLink.vue?vue&type=script&lang=js&"
export * from "./VPlusLink.vue?vue&type=script&lang=js&"
import style0 from "./VPlusLink.vue?vue&type=style&index=0&id=65c46860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c46860",
  null
  
)

export default component.exports